import { Fragment, useState } from "react";
import { useSessionStorage } from "react-use";
import FooterPostup from "../../../../modules/public/footer/footer";
import Menu from "../../../../modules/public/menu/menu";
import CompanySection from "../../../shop/components/CompanySection";
import HeaderSection from "../../../shop/components/HeaderSection";
import SenderAddress from "../../../shop/components/SenderAddress";
import ShipmentSectionAvaBox from "./components/ShipmentSectionAvaBox";

const AvaBox = () => {
  const [mustCollected, setMustCollected] = useState(0);
  const [partCount, setPartCount] = useState(0);

  const [company, setCompany] = useSessionStorage("company", {
    selected: {},
    value: -1,
  });

  const [senderAddress, setSenderAddress] = useSessionStorage("SAddress", {});

  return (
    <Fragment>
      <Menu />
      <main className="flex-grow-1 rtl-all content-box py-3">
        <HeaderSection
          type={2}
          mustCollected={mustCollected}
          partCount={partCount}
        />
        <SenderAddress
          state={{ senderAddress, setSenderAddress }}
          setMustCollected={setMustCollected}
          setPartCount={setPartCount}
        />
        <CompanySection state={{ company, setCompany }} type={2} />
        <ShipmentSectionAvaBox
          company={company}
          senderAddress={senderAddress}
        />
      </main>
      <FooterPostup />
    </Fragment>
  );
};

export default AvaBox;
